<template>
	<div class="messaging-drawer" v-loading="is_loading">
		<b-container v-if="showPage">
			<chats></chats>
		</b-container>
		<b-container v-if="!showPage && !is_loading">
			<i>Invalid Token</i>
		</b-container>
	</div>
</template>
<script>
import { Option, Select, Tabs, TabPane } from 'element-ui'
import Chats from '@/views/Messaging/Chats/MessagingChats'
// import MessagingDocuments from '@/views/Messaging/Documents/MessagingDocuments'
// import ActivityLogs from '@/views/Messaging/Logs/MessagingLogs'
import { mapActions, mapState } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import { useAuthStore } from '@/stores/authStore'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'

export default {
	components: {
		Chats,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane,
	},
	data() {
		return {
			is_loading: false,
			showPage: false,
		}
	},
	created(){
		this.initPage()
	},
	beforeUnmount() {
		this.cleanPage()
	},
	computed: {
		...mapState(useMessagingStore, ['message_profile']),
	},
	methods: {
		...mapActions(useAuthStore, ['fetchUserInfo']),
		...mapActions(useMessagingStore, ['getGroupMessageList', 'setMessageProfile', 'resetMessages', 'setSelectedGroup', 'updateLoadingMessage', 'getAvailableUserByProfile','checkUserGroup']),
		
		async initPage() {
			this.is_loading = true;
			this.showPage = false;
			let queryObj = JSON.parse(atob(this.$route.query.payload));
			const data = _gHlp.getValue(queryObj,'data',{})
				
			this.updateLoadingMessage(true)
			this.showMessagingDrawer = true;
			this.resetMessages()
			this.setSelectedGroup(null);
			this.setMessageProfile(data.profile)

			//AUTO ADD TO GROUP FOR SAS
			if(_gAuth.isAppSas()){
				let type = _gHlp.getValue(data.profile,'type');
				let is_reshuffe_lead = _gHlp.getValue(data.profile,'is_reshuffe_lead', false);
				let is_lead_owner = _gHlp.getValue(data.profile,'is_lead_owner', false);
				let is_add_all_group = (type != 'lead') || ((type == 'lead') && (!is_reshuffe_lead || !is_lead_owner))
				await this.checkUserGroup(_gAuth.activeUserId(), data.bundle_key, type, is_add_all_group);
			}

			this.getGroupMessageList(data.bundle_key).then(async(resp) => {
				await this.getAvailableUserByProfile()
				chatEventBus.$emit('go-back-to-chat-main')
				this.updateLoadingMessage(false)
				this.is_loading = false;
				this.showPage = true;
			}).catch(err => {
				this.is_loading = false;
				this.showPage = false;
			})
		},
		cleanPage() {
			this.resetMessages()
			this.setMessageProfile(null);
			this.setSelectedGroup(null);
		},
		
	}
}
</script>